import React, { useEffect, useReducer, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Row from 'react-bootstrap/Row';
import Table from 'react-bootstrap/Table';
import { Helmet } from 'react-helmet-async';
import { MdOutlinePayments } from 'react-icons/md';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from '../../toasts';
import DetailPageLoader from '../../components/DetailPageLoader/DetailPageLoader';
import MessageBox from '../../components/MessageBox';
import Pagination from '../../components/Pagination';
import paymentService from '../../services/payment.service';
import { getError } from '../../utils';
import { useLabels } from '../../hooks/useLabels';

const reducer = (state, action) => {
	switch (action.type) {
	case 'FETCH_REQUEST':
		return { ...state, loading: true };
	case 'FETCH_SUCCESS':
		return { ...state, payments: action.payload, loading: false };
	case 'FETCH_FAIL':
		return { ...state, loading: false, error: action.payload };
	case 'DELETE_REQUEST':
		return { ...state, loadingDelete: true, successDelete: false };
	case 'DELETE_SUCCESS':
		return {
			...state,
			loadingDelete: false,
			successDelete: true,
		};
	case 'DELETE_FAIL':
		return { ...state, loadingDelete: false, successDelete: false };

	case 'DELETE_RESET':
		return { ...state, loadingDelete: false, successDelete: false };
	default:
		return state;
	}
};

function PaymentList() {
	const { t } = useLabels();
	const [{ loading, error, payments, successDelete }, dispatch] = useReducer(reducer, {
		payments: [],
		loading: true,
		error: '',
	});

	const navigate = useNavigate();

	//pagination
	const [currentPage, setCurrentPage] = useState(1);
	const [postsPerPage] = useState(15); //maxPostsperPage
	const indexOfLastPost = currentPage * postsPerPage;
	const indexOfFirstPost = indexOfLastPost - postsPerPage;
	const currentPosts = payments.slice(indexOfFirstPost, indexOfLastPost);
	//change page
	const paginate = (pageNumber) => setCurrentPage(pageNumber);

	useEffect(() => {
		const fetchData = async () => {
			try {
				dispatch({ type: 'FETCH_REQUEST' });
				const { data } = await paymentService.list();
				dispatch({ type: 'FETCH_SUCCESS', payload: data });
			} catch (err) {
				dispatch({ type: 'FETCH_FAIL', payload: getError(err) });
			}
		};
		if (successDelete) {
			dispatch({ type: 'DELETE_RESET' });
		} else {
			fetchData();
		}
	}, [successDelete]);

	async function deletePaymentHandler(payment) {
		if (window.confirm(t('msg.confirmDeleteCollection'))) {
			try {
				dispatch({ type: 'DELETE_REQUEST' });
				await paymentService.delete(payment._id);
				dispatch({ type: 'DELETE_SUCCESS' });
				toast.success('cobro Eliminado');
			} catch (err) {
				toast.error(getError(err));
				dispatch({ type: 'DELETE_FAIL' });
			}
		}
	}

	async function verComprobante(payment) {
		if (payment.comprobante) {
			window.open(payment.comprobante.fileLink, '_blank', 'noopener,noreferrer');
		}
	}

	async function editPaymentHandler(payment) {
		navigate(`/AdminScreen/payments/editPayment/${payment._id}`);
	}
	async function seeDetails(payment) {
		navigate(`/AdminScreen/payments/payment/${payment._id}`);
	}
	async function newPaymentHandler() {
		navigate('/AdminScreen/newPayment');
	}
	return loading ? (
		<DetailPageLoader entityLabel='pagos' />
	) : error ? (
		<MessageBox variant='danger'>{error}</MessageBox>
	) : (
		<div>
			<Helmet>
				<title>Lista de Pagos</title>
			</Helmet>

			<div className='container admin-con'>
				<div className='row adminProdBtnRow align-items-center'>
					<Row style={{ margin: '5% 0 2.5%' }}>
						<Col>
							<h1 className='text-right'>
								<MdOutlinePayments></MdOutlinePayments>Lista de Cobros
							</h1>
						</Col>
						<Col style={{ display: 'flex', justifyContent: 'flex-end' }}>
							<Button
								className='btn btn-dark m-2'
								value='Crear Cuenta'
								onClick={() => newPaymentHandler()}
							>
								Agregar Cobro
							</Button>
						</Col>
					</Row>
					<Table bordered hover responsive size='sm'>
						<thead>
							<tr>
								<th>ID</th>
								<th>Monto</th>
								<th>Deudor</th>
								<th>Deuda/Cuota</th>
								<th>Fecha</th>
								<th>Cuenta</th>
								<th>Carpeta</th>
								<th className='col-1'>Opciones</th>
							</tr>
						</thead>
						{payments
							? currentPosts.map((payment) => (
								<tbody key={payment._id}>
									<tr key={payment._id}>
										<td>
											<Link to={`payment/${payment._id}`}>{payment.customId}</Link>
										</td>
										<td>{payment.amount}</td>
										{payment.debt ? (
											<td>
												<Link to={`/AdminScreen/debts/debt/${payment.debt._id}`}>
													{payment.debt.customId}
												</Link>
											</td>
										) : (
											<td></td>
										)}
										{payment.debtDue ? <td>{payment.debtDue.customId}</td> : <td></td>}
										{payment.date ? <td>{payment.date.substring(0, 10)}</td> : <td></td>}
										{payment.debt.owner ? (
											<td>
												<Link to={`/AdminScreen/accounts/account/${payment.debt.owner._id}`}>
													{payment.debt.owner.name}
												</Link>
											</td>
										) : (
											<td></td>
										)}
										<td>{payment.folder}</td>
										<td>
											<DropdownButton drop='start' title=''>
												<Dropdown.Item eventKey='0' onClick={() => seeDetails(payment)}>
														Ver Detalles
												</Dropdown.Item>
												{payment.comprobante ? (
													<Dropdown.Item eventKey='1' onClick={() => verComprobante(payment)}>
															Ver Comprobante
													</Dropdown.Item>
												) : (
													''
												)}
												<Dropdown.Item eventKey='1' onClick={() => editPaymentHandler(payment)}>
														Editar
												</Dropdown.Item>
												<Dropdown.Item eventKey='2' onClick={() => deletePaymentHandler(payment)}>
														Eliminar
												</Dropdown.Item>
											</DropdownButton>
										</td>
									</tr>
								</tbody>
							))
							: ''}
					</Table>
					<Pagination
						postsPerPage={postsPerPage}
						totalPosts={payments.length}
						paginate={paginate}
					></Pagination>
				</div>
			</div>
		</div>
	);
}

export default PaymentList;
